import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { formatErr } from "@/lib/api";
import GoogleButton from "@/components/GoogleButton";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({
    full_name: "",
    email: "",
    mobile: "",
    password: "",
    referral_code: params.get("ref") || "",
  });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      await register(form);
      navigate("/welcome");
    } catch (e) { setErr(formatErr(e)); }
    finally { setLoading(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="min-h-screen zfd-canvas flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-lg">
        <div className="text-center mb-8">
          <div className="text-[10px] uppercase tracking-[0.32em] text-[#FBBF24] font-bold mb-2">Zenith Flow Dynamics</div>
          <h1 className="font-display text-4xl font-black tracking-tight">Operator Registration</h1>
        </div>
        <form onSubmit={submit} className="glass-card p-7 space-y-4">
          <GoogleButton testid="reg-google" label="Sign up with Google" />
          <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.22em] text-white/40 font-bold">
            <div className="flex-1 h-px bg-white/10" />
            or with email
            <div className="flex-1 h-px bg-white/10" />
          </div>
          <div className="bg-[#FBBF24]/10 border border-[#FBBF24]/30 rounded-md p-3 text-xs text-[#FBBF24]" data-testid="reg-real-name-notice">
            <strong>Use your real name as printed on your ID.</strong> Your name becomes locked at KYC verification —
            and your GCash or PayMaya payout account name must match it exactly. Withdrawals to mismatched names are rejected.
          </div>
          <div>
            <label className="zfd-label">Full Legal Name</label>
            <input data-testid="reg-name" required className="zfd-input" value={form.full_name} onChange={upd("full_name")} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="zfd-label">Email</label>
              <input data-testid="reg-email" type="email" required className="zfd-input" value={form.email} onChange={upd("email")} />
            </div>
            <div>
              <label className="zfd-label">Mobile (GCash/Maya)</label>
              <input data-testid="reg-mobile" required className="zfd-input" value={form.mobile} onChange={upd("mobile")} />
            </div>
          </div>
          <div>
            <label className="zfd-label">Password (min 6)</label>
            <input data-testid="reg-password" type="password" required minLength={6} className="zfd-input" value={form.password} onChange={upd("password")} />
          </div>
          <div>
            <label className="zfd-label">Guild Referral Code (optional)</label>
            <input data-testid="reg-ref" className="zfd-input" value={form.referral_code} onChange={upd("referral_code")} />
          </div>
          {err && <div data-testid="reg-error" className="text-sm text-[#FCA5A5] bg-[#DC2626]/15 border border-[#DC2626]/40 rounded-md p-3">{err}</div>}
          <button data-testid="reg-submit" disabled={loading} className="btn-deploy w-full disabled:opacity-50">
            {loading ? "Provisioning…" : "Launch Operator Account"}
          </button>
          <div className="text-center text-sm text-white/60 pt-1">
            Have an account? <Link to="/login" className="text-[#FBBF24] hover:underline font-semibold" data-testid="goto-login">Sign in</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
